import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import QuestionIcon from '@grnhse/seedling/lib/birch/components/tooltips/tooltip_question_icon';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

const Description = styled.div`
  p {
    margin: 5px 0;
  }

  a {
    color: ${FullPalette.GREEN_700};
  }
`;

const LinkifiedTooltip = ({ description }: { description: string }) => (
  <Tooltip
    // eslint-disable-next-line react/no-danger
    label={<Description dangerouslySetInnerHTML={{ __html: description }} />}
    ariaLabel={description}
  >
    <QuestionIcon />
  </Tooltip>
);

export default LinkifiedTooltip;
